import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { browserHistory } from 'react-router';
import styles from './../ImpactsEmbed/ImpactsEmbed.css';
import withStyles from '../../decorators/withStyles';
import ImpactsData from '../ImpactsData';


const ImpactTableSlide = props => {
  return <div></div>
};


class ImpactsEmbed extends Component {

  render() {

    return (
      <div className="band light">
        <section>
          <ImpactsData>
            <ImpactTableSlide />
          </ImpactsData>
        </section>
        <div className="cc-logo-img"></div>
      </div>
    )
  }

}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(ImpactsEmbed);
